import { render } from "./LegalPage.vue?vue&type=template&id=d5457090"
import script from "./LegalPage.vue?vue&type=script&lang=js"
export * from "./LegalPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__